/**
 * Locale constants shared by server and client code.
 *
 * Kept free of any next-intl/server imports so client components (and modules
 * they pull in, such as lib/seo.ts) can import it without dragging the server
 * runtime into the browser bundle.
 */
export const locales = ["en", "es"] as const;
export const defaultLocale = "en" as const;
export const defaultTimeZone = "UTC" as const;

export type Locale = (typeof locales)[number];
